<template>
  <div>
    <v-text-field
      v-model="cmpValue"
      v-bind:label="label"
      v-bind:placeholder="placeholder"
      v-bind:readonly="readonly"
      v-bind:disabled="disabled"
      v-bind:outlined="outlined"
      v-bind:dense="dense"
      v-bind:hide-details="hideDetails"
      v-bind:error="error"
      v-bind:rules="rules"
      v-bind:clearable="clearable"
      v-bind:backgroundColor="backgroundColor"
      v-bind:prefix="options.type === 'currency' ? prefixCurrency : options.prefix"
      v-bind:suffix="options.type === 'currency' ? suffixCurrency : options.suffix"
      v-on:keydown="options.type === 'currency' ? keyCurrencyDown($event,usedCurrency, allowMinusNumber, false) : keyPress"
      :key="forceRenderKey"
      ref="textField"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  model: { prop: "value", event: "input" },
  props: {
    value: {
      // type: String,
      type: [String, Number],
      default: "0",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: [Boolean, String],
      default: false,
    },
    rules: {
      type: [Array, String],
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: "white",
    },
    valueWhenIsEmpty: {
      type: String,
      default: "", // "0" or "" or null
    },
    options: {
      type: Object,
      default: function () {
        return {
          type: null,
          locale: "pt-BR",
          prefix: "",
          suffix: "",
          length: 11,
          precision: 2,
          checkPercentage: false
        };
      },
    },
    allowMinusNumber: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      forceRenderKey: 0,
      timeout: null,
    }
  },
  computed: {
    cmpValue: {
      get: function () {
        if (this.value === null || this.value === "") {
          return this.valueWhenIsEmpty;
        }
        const valueStr = this.value.toString();
        if (this.options.type && this.options.type === 'currency') {
          return this.convertDecimalViaLocal(valueStr, this.allowMinusNumber);
        }
        return this.humanFormat(valueStr);
      },
      set: function (newValue) {
        if (this.options.type && this.options.type == 'currency') {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            const value = this.setCurrency(newValue, this.allowMinusNumber);
            this.$emit("input", value);
            if (this.value == value) {
              this.forceRenderKey++;
              this.$nextTick(() => {
                if (this.$refs.textField) {
                    this.$refs.textField.focus();
                }
              });
            }
          }, this.allowMinusNumber && newValue.toString().length == 1 && newValue.startsWith('-') ? 1000 : this.timeOutChange(newValue));
        } else {
          this.$emit("input", this.machineFormat(newValue));
        }
      },
    },
  },
  methods: {
    keyDecimal() {
      if (!this.options.type || this.options.type !== 'currency') return null;
      const localeData = this.currencyData.locales[this.$i18n.locale];
      const decimal = localeData && localeData.decimal ? localeData.decimal : null;
      return decimal === ',' ? 44 : decimal === '.' ? 46 : null;
    },
    humanFormat: function (number) {
      if (isNaN(number)) {
        number = "";
      } else {
        number = Number(number).toLocaleString(this.options.locale, {
          maximumFractionDigits: this.options.precision,
          minimumFractionDigits: this.options.precision,
        });
      }
      return number;
    },
    machineFormat(number) {
      if (number) {
        number = this.cleanNumber(number);
        number = number.padStart(parseInt(this.options.precision) + 1, "0");
        number =
          number.substring(0, number.length - parseInt(this.options.precision)) +
          "." +
          number.substring(
            number.length - parseInt(this.options.precision),
            number.length
          );
        if (isNaN(number)) {
          number = this.valueWhenIsEmpty;
        }
      } else {
        number = this.valueWhenIsEmpty;
      }
      if (this.options.precision === 0) {
        number = this.cleanNumber(number);
      }
      if (this.options.checkPercentage == true) {
        number = this.processValue(number);
      }
      return number;
    },
    keyPress($event) {
      const decimalKey = this.keyDecimal();
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 45 && (decimalKey && keyCode !== decimalKey)) {
        $event.preventDefault();
      }
      if (this.targetLength()) {
        $event.preventDefault($event);
      }
    },
    cleanNumber: function (value) {
      let result = "";
      if (value) {
        let flag = false;
        let arrayValue = value.toString().split("");
        for (var i = 0; i < arrayValue.length; i++) {
          if (this.isInteger(arrayValue[i])) {
            if (!flag) {
              if (arrayValue[i] !== "0") {
                result = result + arrayValue[i];
                flag = true;
              }
            } else {
              result = result + arrayValue[i];
            }
          } else if (i === 0 && arrayValue[i] === "-") {
            result = result + arrayValue[i];
          }
        }
      }
      return result;
    },
    isInteger(value) {
      let result = false;
      if (Number.isInteger(parseInt(value))) {
        result = true;
      }
      return result;
    },
    targetLength() {
      if (Number(this.cleanNumber(this.value).length) >= Number(this.options.length)) {
        return true;
      } else {
        return false;
      }
    },
    processValue(number) {
      let [start = '0', end = '00'] = number.split(".");
      if(start.startsWith("-")) {
        start = start.substring(0, 3);
      } else {
        start = start.substring(0, 2);
      }
      end = end.substring(0, 2);
      return start+"."+end;
    },
  },
};
</script>
